import { render } from "./demo-block.vue?vue&type=template&id=31284776"
import script from "./demo-block.vue?vue&type=script&lang=js"
export * from "./demo-block.vue?vue&type=script&lang=js"

import "./demo-block.vue?vue&type=style&index=0&id=31284776&lang=scss"
script.render = render

export default script